import { useState, useRef } from 'react';
import styles from '../../assets/css/AccountForgotUsernamePassword.module.css';
import Reaptcha from 'reaptcha';
import { IconAngleRight, IconLoadingCircle } from '@ace/react-icons';

const AccountForgotUsername = (props) => {
    const baseUrl = '/api/account';
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [isInputChanged, setIsInputChanged] = useState(false);
    const [emailSubmitted, setEmailSubmitted] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
    const captchaRef = useRef(null);

    const onEmailInputChange = (e) => {
        const providedEmail = e.target.value;

        setIsInputChanged(true);

        if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i).test(providedEmail)) {
            setIsEmailValid(false);
            return;
        }
        setIsEmailValid(true);
        setEmail(providedEmail);
    }

    const verifyCaptcha = () => {
        captchaRef.current.getResponse()
            .then(response => {
                setCaptchaToken(response)
            })
    }

    const onCaptchaExpired = () => {
        setCaptchaToken(null)
    }

    const onSubmitButtonClick = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const data = { email: email }
        fetch(`${baseUrl}/send-username`, {
            method: 'POST',
            headers: {
                'X-REQUESTED-WITH': 'XMLHttpRequest',
                'Content-Type': 'application/json',
                'RequestVerificationtoken': props.RequestVerificationToken
            },
            body: JSON.stringify(data)
        }).then(() => {
            setEmailSubmitted(true);
            setIsLoading(false);
        })
    }

    return (
        <div className={styles.wrapper}>
            <h1>Forgot your username?</h1>
            <p>Enter the email address associated with your ACE Business Account and we will send your username.</p>
            <input type="text" name="email" id="email" placeholder="Enter email address" onChange={onEmailInputChange} />
            {isInputChanged && !isEmailValid && <span className={styles.error}>Please enter a valid email address</span>}
            <div className={styles.recaptchaWrap}>
                <Reaptcha
                    sitekey={process.env.RECAPTCHA_APP_KEY}
                    ref={captchaRef}
                    onVerify={verifyCaptcha}
                    onExpire={onCaptchaExpired}
                />
            </div>
            {(isEmailValid && captchaToken && !emailSubmitted && !isLoading) &&
                <button className={'ace-btn-primary'} onClick={e => onSubmitButtonClick(e)}>Submit <IconAngleRight /></button>
            }
            {isLoading && <IconLoadingCircle />}
            {emailSubmitted &&
                <p>
                    An email has been sent with your account username associated with the email address provided. If you don't receive an email, please call us at 1-888-825-3636 or <a href="https://www.acefitness.org/btob/requestfacultylogin.aspx">request your login credentials online</a>.
                </p>
            }
        </div>)
}

export default AccountForgotUsername;